import { Container } from '@pixi/display';
import { Text } from '@pixi/text';
import LocalisedText from './LocalisedText';

export class RankStatPair extends Container
{
    private content: Container;
    private pointsLabel: LocalisedText;
    private pointsValue: Text;

    constructor()
    {
        super();

        this.content = new Container();
        this.addChild(this.content);

        this.pointsLabel = new LocalisedText('', {
            fontFamily: 'lubalin',
            fill: 0x90C9E3,
            align: 'center',
            fontSize: 20,
            stroke: 0x333333,
            strokeThickness: 6,
            lineJoin: 'round',
            maxWidth: 350
        });
        this.pointsLabel.anchor.set(0.5, 1);
        this.content.addChild(this.pointsLabel);
        this.pointsLabel.y = 5;

        this.pointsValue = new Text('', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'center',
            fontSize: 29,
            stroke: 0x333333,
            strokeThickness: 6,
            lineJoin: 'round',
        });
        this.pointsValue.anchor.set(0.5, 0);
        this.content.addChild(this.pointsValue);
        this.pointsValue.y = -6;
    }

    public refresh(key: string, value: string | number): void
    {
        this.pointsLabel.setText(key);
        this.pointsValue.text = String(value);
    }
}
